import React, { useState } from 'react';
import { Edit, Trash2, GripVertical, CheckCircle, Circle } from 'lucide-react';

const FIELD_TYPE_LABELS = {
  text: 'Text',
  textarea: 'Textarea',
  email: 'Email',
  phone: 'Phone',
  number: 'Number',
  select: 'Dropdown',
  radio: 'Radio',
  checkbox: 'Checkbox'
};

const RSVPFieldList = ({ fields, onEdit, onDelete, onReorder }) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index) return;

    const newFields = [...fields];
    const draggedField = newFields[draggedIndex];
    newFields.splice(draggedIndex, 1);
    newFields.splice(index, 0, draggedField);

    setDraggedIndex(index);
    onReorder(newFields);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  if (fields.length === 0) {
    return (
      <div className="empty-state">
        <p>No custom fields yet.</p>
        <p className="empty-subtitle">Click "Add Field" to create your first custom RSVP field.</p>
      </div>
    );
  }

  return (
    <div className="field-list">
      <div className="field-list-header">
        <span className="field-list-title">
          {fields.length} custom {fields.length === 1 ? 'field' : 'fields'}
        </span>
        <small className="field-list-subtitle">Drag to reorder</small>
      </div>

      <div className="field-cards">
        {fields.map((field, index) => (
          <div
            key={field.id}
            className={`field-card ${draggedIndex === index ? 'dragging' : ''}`}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDragEnd={handleDragEnd}
          >
            <div className="field-card-drag-handle">
              <GripVertical size={20} />
            </div>

            <div className="field-card-content">
              <div className="field-card-header">
                <div>
                  <h4 className="field-card-label">
                    {field.field_label}
                    {field.is_required && <span className="required-badge">Required</span>}
                  </h4>
                  <span className="field-card-type">
                    {FIELD_TYPE_LABELS[field.field_type] || field.field_type}
                  </span>
                </div>
              </div>

              {field.help_text && (
                <p className="field-card-help">{field.help_text}</p>
              )}

              {field.options && field.options.length > 0 && (
                <div className="field-card-options">
                  <small><strong>Options:</strong> {field.options.join(', ')}</small>
                </div>
              )}
            </div>

            <div className="field-card-actions">
              <button
                className="btn-icon"
                onClick={() => onEdit(field)}
                title="Edit field"
              >
                <Edit size={18} />
              </button>
              <button
                className="btn-icon-danger"
                onClick={() => onDelete(field.id)}
                title="Delete field"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RSVPFieldList;
